import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectEsbAuditLogListItems } from "../../../../../redux/esb-audit-logs/selector";
import { esbAuditLog } from "../../../../../redux/esb-audit-logs/action";
import Table from "../../../../../common/components/table";
import PageLoader from "../../../../../components/PageLoader";

const EsbAuditLogs = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const esbAuditLogItems = useSelector(selectEsbAuditLogListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'EventName', headerName: 'EventName', searchField: 'EventName', filter: true,
        filterType: 'text'
      },
      {
        field: 'LogDescription', headerName: 'LogDescription', searchField: 'LogDescription', filter: true,
        filterType: 'text'
      },
      {
        field: 'Status', headerName: 'Status', searchField: 'Status', filter: true,
        filterType: 'text'
      },
   
    ]);
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(esbAuditLog.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/esb-audit-logs/list`,
      entity: 'esbAuditLog', jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

 const fetchesbAuditLog = () => {
    dispatch(esbAuditLog.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/esb-audit-logs/list`,
      entity: 'esbAuditLog',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleReloadData = () => {
   fetchesbAuditLog()
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

 
  const handleAdd = () => {
    navigate(`${0}`);
  };

  const additionButtons: any = [

    
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    },
  ];

  useEffect(() => {
    createColumnDefs()
    fetchesbAuditLog()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(esbAuditLog.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/esb-audit-logs/delete`,
      entity: 'esbAuditLog',
      jsonData: {
        Context: {},

        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchesbAuditLog();
    });
  }
  return (
    <>
      {esbAuditLogItems?.isLoading ? <PageLoader /> :
        <Table enableFilter={true}
          filterTypeLists={filterTypes}
          onSearch={handleSearch} columnData={columnDefs}
          rowData={esbAuditLogItems?.result?.items} setPageData={setPageData}
          setPageSize={setPageSize} paginationData={esbAuditLogItems?.result?.pagination}
          onEdit={handleEdit} additionButtons={additionButtons}
          onDelete={handleDelete} headingName="Esb Audit Log"
        />
      }
    </>
  );
};

export default EsbAuditLogs;